import { ORDER_TYPES } from '@/pages/cars/returnCar/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

// 订单查询方式，carId: 按车牌号查询 customerId: 按客户姓名查询
export const ORDER_QUERY_BY_CARID = 'carId'
export const ORDER_QUERY_BY_CUSTOMERID = 'customerId'

export const mixin = {
  data() {
    return {
      orderQueryType: ORDER_QUERY_BY_CARID,
      returnCarInfo: {
        list: [
          {
            el: 'select',
            itemConfig: {
              label: '车牌号',
              prop: 'carId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: true,
              popperAppendToBody: false,
              remoteMethod: (query) => {
                this.gerCarList(query)
              },
              loading: false,
              placeholder: '请输入',
              options: {
                label: 'plateNo',
                value: 'id',
                list: [],
              },
              style: {
                width: '220px',
              },
            },
            isShow: true,
            extra: () => {
              return <el-button type="text" style="font-size: 12px" onClick={(e) => {
                e.stopPropagation()
                this.handelOrderQueryTypeToggle()
              }}>通过客户名称查询</el-button>
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'customerId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: true,
              popperAppendToBody: false,
              remoteMethod: this.getCustomerList,
              loading: false,
              placeholder: '请输入',
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
              events: {
                change: () => {
                  this.$set(this.returnCarInfo.model, 'orderId', '')
                },
              },
              jsxRender: (option) => {
                return <CustomerNameOptionItem data={option} />
              },
              style: {
                width: '220px',
              },
            },
            isShow: false,
            extra: () => {
              return <el-button type="text" style="font-size: 12px" onClick={(e) => {
                e.stopPropagation()
                this.handelOrderQueryTypeToggle()
              }}>通过车牌号查询</el-button>
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '所属部门',
              prop: 'deptName',
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '租期',
              prop: 'orderId',
            },
            elConfig: {
              placeholder: '请选择租期',
              options: {
                label: 'label',
                value: 'value',
                list: [],
              },
              style: {
                width: '220px',
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '退车类型',
              prop: 'returnType',
            },
            elConfig: {
              placeholder: '请选择退车类型',
              disabled: true,
              options: {
                label: 'name',
                value: 'value',
                list: [],
              },
              style: {
                width: '220px',
              },
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '退车原因',
              prop: 'returnReason',
              type: 'textarea',
            },
            elConfig: {
              type: 'textarea',
              maxlength: 50,
              showWordLimit: true,
              placeholder: '请输入退车原因',
              style: {
                width: '220px',
              },
            },
          },
        ],
        model: {
          carId: '', // 车牌号
          customerId: '', // 客户名称
          deptName: '', // 所属部门名称
          orderId: '', // 订单ID
          returnType: '', // 退车类型
          returnReason: '', // 退车原因
        },
        rules: {
          carId: [
            { required: this.orderQueryType === ORDER_QUERY_BY_CARID, message: '请选择', trigger: 'change' },
          ],
          customerId: [
            { required: this.orderQueryType === ORDER_QUERY_BY_CUSTOMERID, message: '请选择', trigger: 'change' },
          ],
          orderId: [
            { required: true, message: '请选择', trigger: 'change' },
          ],
          returnType: [
            { required: true, message: '请选择', trigger: 'change' },
          ],
          returnReason: [
            { required: true, message: '请填写', trigger: 'blur' },
          ],
        },
      },
      carInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '车牌号',
              prop: 'plateNo',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆ID',
              prop: 'carId',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '品牌',
              prop: 'brandName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车系',
              prop: 'seriesName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车型',
              prop: 'modelName',
              width: 160,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆状态',
              prop: 'carState',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '库存状态',
              prop: 'inventoryState',
            },
          },
        ],
        model: {
          plateNo: '', // 车牌号
          carId: '', // 车辆ID
          brandName: '',
          seriesName: '',
          modelName: '', // 车型
          carState: '', // 车辆状态
          inventoryState: '', // 库存状态
        },
      },
      orderInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '订单ID',
              prop: 'id',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '企业主订单ID',
              prop: 'entRentOrderId',
            },
            isShow: this.orderType === ORDER_TYPES.enterprise.value,
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单类型',
              prop: 'type',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单状态',
              prop: 'state',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '收款起止日',
              prop: 'receivablePeriod',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '赠送天数',
              prop: 'presentDays',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '免租周期',
              prop: 'presentDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '租金总金额',
              prop: 'totalAmount',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '押金金额',
              prop: 'totalDeposit',
            },
          },
        ],
        model: {
          id: '', // 订单ID
          entRentOrderId: '', // 企业主订单ID
          type: '', // 订单类型
          state: '', // 订单状态
          receivablePeriod: '', // 收款起止日
          presentDays: '', // 赠送天数
          presentDate: '', // 免租周期 presentStartDate presentEntDate
          totalAmount: '', // 每期租金
          totalDeposit: '', // 押金
        },
      },
      customerInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '客户ID',
              prop: 'customerId',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户类型',
              prop: 'customerType',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
          },
        ],
        model: {
          customerId: '', // 客户ID
          customerType: '', // 客户类型
          customerName: '', // 客户名称
        },
      },
    }
  },
  methods: {
  },
}
